import React from 'react'
import MultiSelectWithSelectAll from '@ublique/components/MultiSelect/MultiSelectWithSelectAll'
import { useTranslation } from 'react-i18next'
import '../index.scss'
const itemToString = (item) => (item ? item.text : '')

const Multiselect = ({
  id,
  title,
  selected,
  items = [],
  onChange,
  placeholder,
  disabled
}) => {
  const { t } = useTranslation('Common')

  const getKey = () => `key-${!selected}`

  return (
    <MultiSelectWithSelectAll
      className='store-collaboration-multi-select'
      key={getKey()}
      btnLabels={{
        select: t('ExtraOutput:StoreCollaboration.SELECT_ALL'),
        deselect: t('ExtraOutput:StoreCollaboration.DESELECT_ALL')
      }}
      id={id}
      selectOptions
      titleText={title}
      label={t('Select')}
      placeholder={placeholder || t('Select')}
      items={items}
      disabled={disabled}
      itemToString={itemToString}
      onChange={onChange}
      initialSelectedItems={selected}
    />
  )
}

export default Multiselect
